<template>

    <textarea :name="name" style="height:250px;" rows="10" class="input-memo"
              v-model="value"></textarea>

</template>

<script>
    let $ = require('jquery');
    window.$ = $;
    window.jQuery = $;

    let loadFroalaScripts = function(callback){
        let present = false;
        let scriptSrc = '/Content/custom/Froala/htmleditor.min.js';
        let scripts = document.getElementsByTagName('script');
        for (let i = scripts.length; i--;) {
            if (scripts[i].src === scriptSrc){
                present = true;
                break;
            }
        }

        if(!present){
            let link1 = document.createElement('link');
            link1.setAttribute('rel', 'stylesheet');
            link1.setAttribute('type', 'text/css');
            link1.href = '/Content/custom/Froala/htmleditor.min.css';
            document.head.appendChild(link1);

            let link2 = document.createElement('link');
            link2.href = '/Content/custom/FontAwesome/css/font-awesome.css';
            link2.setAttribute('rel', 'stylesheet');
            link2.setAttribute('type', 'text/css');
            document.head.appendChild(link2);

            let script = document.createElement('script');
            script.onload = function () {
                callback();
            };
            script.src = scriptSrc;
            document.head.appendChild(script);
        }else{
            callback();
        }
    };
    let froala;

    export default {
        name: "froala-editor",

        props: ['name', 'value', 'imageUploadURL', 'imageMaxSize', 'height'],

        data(){
            return {
                body: null,
                queueAction: null
            }
        },

        watch: {
            value(newVal, oldVal) {
                //$(this.$el).froalaEditor('html.set', newVal);
            }
        },

        methods:{
            getHtml(){
                return $(this.$el).froalaEditor('html.get');
            },

            setHtml(newVal){
                let vm = this;
                if(froala) {
                    $(this.$el).froalaEditor('html.set', newVal);
                }else{
                    this.queueAction = function () {
                        $(vm.$el).froalaEditor('html.set', newVal);
                    }
                }
            },

            insert(text){
                let vm = this;
                if(froala) {
                    $(vm.$el).froalaEditor('html.insert', text);
                }else{
                    this.queueAction = function () {
                        $(vm.$el).froalaEditor('html.insert', text);
                    }
                }
            }
        },

        mounted () {
            let vm = this;

            loadFroalaScripts(function () {
                let toolbarButtons = [
                    'undo', 'redo', '|', 'bold', 'italic', 'underline', '|',
                    'fontSize', 'color', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', 'quote', '|',
                    'insertLink', 'insertTable', 'insertHR'];
                if(vm.imageUploadURL){
                    toolbarButtons.splice(18, 0, 'insertImage');
                }

                froala = $(vm.$el).froalaEditor({
                    language: 'ru',
                    toolbarButtons: toolbarButtons,
                    charCounterCount: false,
                    videoUpload: false,
                    useClasses: false,

                    imageSplitHTML: true,
                    imageUploadURL: vm.imageUploadURL || '',
                    imageUploadMethod: 'POST',
                    imageMaxSize: vm.imageMaxSize || 10*1024*1024,
                    imageAllowedTypes: ['jpeg', 'jpg', 'png'],
                    height: vm.height || 0
                });

                $(vm.$el).on('froalaEditor.contentChanged', function () {
                    vm.$emit('input', $(vm.$el).froalaEditor('html.get', true));
                });

                if (vm.queueAction) {
                    vm.queueAction();
                    vm.queueAction = null;
                }
            });
        },

        destroyed(){
            $(this.$el).froalaEditor('destroy');
            $(this.$el).remove();
        }
    }
</script>


// WEBPACK FOOTER //
// Content/src/components/FroalaEditor.vue